import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { fetchCountries } from 'redux/users/actions';
import { fetchBillingPlans } from 'redux/billing/actions';

import { Elements as StripeElements } from 'react-stripe-elements';

import { Link } from 'react-router-dom';

import UpdateBillingPlanForm from 'components/dashboard/billing-content/UpdateBillingPlanForm';
import YourCurrentPlanContent from 'components/dashboard/billing-content/YourCurrentPlanContent';
import CommonMessage from 'components/common/CommonMessage';

import './BillingSubscriptionPageContent.css';

class BillingSubscriptionPageContent extends Component {
  static propTypes = {
    fetchCountries: PropTypes.func.isRequired,
    fetchBillingPlans: PropTypes.func.isRequired,
    me: PropTypes.object,
    countries: PropTypes.arrayOf(PropTypes.shape),
    billingPlans: PropTypes.arrayOf(PropTypes.shape),
    billingPlansError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    countries: null,
    billingPlans: null,
    billingPlansError: null,
  };

  componentDidMount() {
    if (!this.props.countries) {
      this.props.fetchCountries();
    }

    if (!this.props.billingPlans) {
      this.props.fetchBillingPlans();
    }
  }

  renderBillingPlansError = () => (
    <CommonMessage
      error
      errors={this.props.billingPlansError}
    />
  );

  render() {
    const { me, countries, billingPlans, billingPlansError } = this.props;
    if (!me) { return null; }
    if (billingPlansError) { return this.renderBillingPlansError(); }
    const currentPlan = me.subscription && me.subscription.billing_plan.title;

    const proPlan = billingPlans &&
      billingPlans.filter(plan => plan.title === 'Pro')[0];

    return (
      <Translation>
        {(t) => (
          <div className="billing-subscription-page-content__component">

            {/* Form */}
            {currentPlan === 'Starter' &&
              <StripeElements>
                <UpdateBillingPlanForm
                  countries={countries}
                  proPlan={proPlan}
                />
              </StripeElements>
            }

            {currentPlan === 'Pro' &&
              me.subscription &&
              <Fragment>
                {!me.subscription.is_manual ?
                  <YourCurrentPlanContent
                    proPlan={proPlan}
                  />
                  :
                  <CommonMessage warning>
                    {t("Oops… it seems you were subscribed manually without any credit card. " +
                       "If you have any questions related to billing, invoices or PRO features, " +
                       "please reach out to")} <a href="mailto:team@heylink.me">team@heylink.me</a>
                  </CommonMessage>
                }
              </Fragment>
            }

            <Link
              className="back-to-billing"
              to="/billing"
            >
              {t("Back to Billing")}
            </Link>

          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    countries: state.usersReducer.countries,
    billingPlans: state.billingReducer.billingPlans,
    billingPlansError: state.billingReducer.billingPlansError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchCountries,
    fetchBillingPlans,
  },
)(BillingSubscriptionPageContent);
